import React, { useContext, useEffect } from 'react'
import { StoresContext } from '@App/contexts'
import PublisherSelector from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/PublisherSelector'
import CatalogTransferWizardHeader from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/CatalogTransferWizardHeader'
import { targetSearchPublishersOptions } from '@App/stores/search/catalog-transfer/target-search-publishers-store'
import clsx from 'clsx'
import { observer } from 'mobx-react'

const TargetPublisherSelectionStep = () => {
    const { transferTargetPublisherSearchStore, catalogTransferWizardStore } = useContext(StoresContext)

    useEffect(() => {
        if (catalogTransferWizardStore.currentCatalogTransfer?.targetPublisher?.ipId) {
            transferTargetPublisherSearchStore.searchCriteriaStore.setCriterionOption(
                0,
                targetSearchPublishersOptions[2],
                catalogTransferWizardStore.currentCatalogTransfer.targetPublisher.hfaPublisherNumber
            )
            transferTargetPublisherSearchStore.setQuery({
                hfaNumber: catalogTransferWizardStore.currentCatalogTransfer.targetPublisher.hfaPublisherNumber,
            })
            transferTargetPublisherSearchStore.search().then()
        } else {
            transferTargetPublisherSearchStore.resetStore()
        }
    }, [])

    return (
        <div className="publisher-selection-step ct-wizard-step-container">
            <CatalogTransferWizardHeader
                title="Publisher Search"
                subtitle="Search for the publisher who will be acquiring the rights to the works."
            >
                <p>This can be your Member name or a publisher name within your hierarchy.</p>
            </CatalogTransferWizardHeader>
            <section
                className={clsx(
                    'publisher-select',
                    transferTargetPublisherSearchStore.searchResults.length && 'has-searched'
                )}
            >
                <PublisherSelector
                    defaultParty={
                        catalogTransferWizardStore.currentCatalogTransfer?.targetPublisher?.ipId?.toString() ??
                        undefined
                    }
                    store={transferTargetPublisherSearchStore}
                    onPublisherSelect={(publisher) => {
                        catalogTransferWizardStore.updateCatalogTransferDTO({
                            targetPublisherIpId: publisher.ipId ?? '',
                        })
                    }}
                />
            </section>
        </div>
    )
}

export default observer(TargetPublisherSelectionStep)
